export default "__VITE_ASSET__204ff2f5__"